define("shared/components/shared/credentials/unconnected-pages", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency"], function (_exports, _component, _templateFactory, _service, _component2, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @closable={{false}} @close={{action @close}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "credentials.unconnected.title"}} />
      <modal.card-body class="u--p__t__0">
        <p>
          {{html-safe (t "credentials.unconnected.unconnected_text" nickname=this.nickname userName=@facebookUser.name)}}
        </p>
        {{! Help Text }}
        <a class="u--block u--m__b__xs" {{on "click" (toggle-action "showHelpDropdown" this)}}>
          {{t "credentials.facebook_connection.question"}}
        </a>
        <p class={{if this.showHelpDropdown "u--fadeIn" "u--hide"}}>
          {{t "credentials.facebook_connection.answer"}}
        </p>
        <div class="o--card u--m__tb__lg">
          <div class="o--cardBody u--p__lr__sm">
            <div class="u--row u--row--noCollapse">
              {{! User Profile }}
              <div class="u--col__5">
                <div class="o--user">
                  <img class="o--user__avatar" src={{this.socialProfile.secureAvatarUrl}} />
                  <span class="o--user__avatarChild--ig"><i class="i--ig--w"></i></span>
                  <span class="o--user__title">{{t "credentials.unconnected.handle" nickname=this.nickname}}</span>
                  <span class="o--user__desc">{{t "shared_words.instagram"}}</span>
                </div>
              </div>
              {{! Link Icon }}
              <div class="u--col__2 u--text--center">
                {{svg-jar "connect" class="o--icon u--m__t__sm"}}
              </div>
              {{! User Profile }}
              <div class="u--col__5">
                <div class="o--user">
                  <img class="o--user__avatar" src={{this.socialProfile.secureAvatarUrl}} />
                  <span class="o--user__avatarChild--facebook"><i class="i--facebook--w"></i></span>
                  <span class="o--user__title u--text--light">{{t "credentials.unconnected.unknown_page"}}</span>
                  <span class="o--user__desc u--text--light">{{t "credentials.unconnected.fb_page"}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="u--text--md u--text--bold" {{did-insert (perform this.trackSelectedPage)}}>
          {{html-safe (t "credentials.unconnected.missing_page")}}
        </p>
        <Shared::Credentials::PageList
          @activePageId={{this.state.activePage.id}}
          @page={{@page}}
          @pages={{@pages}}
          @selectPage={{action @selectPage}}
          @selectPageNotFound={{action @selectPageNotFound}}
          @socialProfile={{this.socialProfile}}
          @state={{this.state}}
        />
        <p class="u--text--md u--m__t__xs">
          {{t "credentials.unconnected.no_page" nickname=this.nickname}}
          <Shared::Link
            @href="https://help.later.com/hc/articles/1500000110062"
            @text={{t "credentials.unconnected.learn_connect"}}
          />
        </p>
      </modal.card-body>
      <modal.card-footer>
        {{#if this.selectedPageBusinessAccountId}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{action @close}}
            @text={{t "shared_words.ok"}}
            @variant="outline"
          />
        {{else if this.activePageHasSufficientPermissions}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{set this "state.currentModal" "docsForNewPage"}}
            @text={{t "shared_words.next"}}
            @variant="primary"
          />
        {{else if this.missingPage}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{set this "state.currentModal" "findNewPage"}}
            @text={{t "shared_words.next"}}
            @variant="primary"
          />
        {{else if (not this.activePageId)}}
          <Shared::Ui::Button
            @additional="block"
            @isDisabled={{true}}
            @text={{t "shared_words.next"}}
            @variant="primary"
          />
        {{else}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{action @close}}
            @text={{t "shared_words.ok"}}
            @variant="outline"
          />
        {{/if}}
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "vZbnWLZM",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@close\"],[false,[28,[37,1],[[30,0],[30,1]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"credentials.unconnected.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,3],[[28,[37,2],[\"credentials.unconnected.unconnected_text\"],[[\"nickname\",\"userName\"],[[30,0,[\"nickname\"]],[30,3,[\"name\"]]]]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[11,3],[24,0,\"u--block u--m__b__xs\"],[4,[38,4],[\"click\",[28,[37,5],[\"showHelpDropdown\",[30,0]],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.facebook_connection.question\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[15,0,[52,[30,0,[\"showHelpDropdown\"]],\"u--fadeIn\",\"u--hide\"]],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.facebook_connection.answer\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--card u--m__tb__lg\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--cardBody u--p__lr__sm\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[1,\"            \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[15,\"src\",[30,0,[\"socialProfile\",\"secureAvatarUrl\"]]],[12],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__avatarChild--ig\"],[12],[10,\"i\"],[14,0,\"i--ig--w\"],[12],[13],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__title\"],[12],[1,[28,[35,2],[\"credentials.unconnected.handle\"],[[\"nickname\"],[[30,0,[\"nickname\"]]]]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,[28,[35,2],[\"shared_words.instagram\"],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[1,\"            \"],[10,0],[14,0,\"u--col__2 u--text--center\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"connect\"],[[\"class\"],[\"o--icon u--m__t__sm\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"],[1,\"            \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[15,\"src\",[30,0,[\"socialProfile\",\"secureAvatarUrl\"]]],[12],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__avatarChild--facebook\"],[12],[10,\"i\"],[14,0,\"i--facebook--w\"],[12],[13],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__title u--text--light\"],[12],[1,[28,[35,2],[\"credentials.unconnected.unknown_page\"],null]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--light\"],[12],[1,[28,[35,2],[\"credentials.unconnected.fb_page\"],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,2],[24,0,\"u--text--md u--text--bold\"],[4,[38,8],[[28,[37,9],[[30,0,[\"trackSelectedPage\"]]],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,3],[[28,[37,2],[\"credentials.unconnected.missing_page\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,10],null,[[\"@activePageId\",\"@page\",\"@pages\",\"@selectPage\",\"@selectPageNotFound\",\"@socialProfile\",\"@state\"],[[30,0,[\"state\",\"activePage\",\"id\"]],[30,4],[30,5],[28,[37,1],[[30,0],[30,6]],null],[28,[37,1],[[30,0],[30,7]],null],[30,0,[\"socialProfile\"]],[30,0,[\"state\"]]]],null],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--m__t__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.unconnected.no_page\"],[[\"nickname\"],[[30,0,[\"nickname\"]]]]]],[1,\"\\n        \"],[8,[39,11],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500000110062\",[28,[37,2],[\"credentials.unconnected.learn_connect\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"selectedPageBusinessAccountId\"]],[[[1,\"        \"],[8,[39,12],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[[30,0],[30,1]],null],[28,[37,2],[\"shared_words.ok\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"activePageHasSufficientPermissions\"]],[[[1,\"        \"],[8,[39,12],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,13],[[30,0],\"state.currentModal\",\"docsForNewPage\"],null],[28,[37,2],[\"shared_words.next\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"missingPage\"]],[[[1,\"        \"],[8,[39,12],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,13],[[30,0],\"state.currentModal\",\"findNewPage\"],null],[28,[37,2],[\"shared_words.next\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,14],[[30,0,[\"activePageId\"]]],null],[[[1,\"        \"],[8,[39,12],null,[[\"@additional\",\"@isDisabled\",\"@text\",\"@variant\"],[\"block\",true,[28,[37,2],[\"shared_words.next\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,12],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[[30,0],[30,1]],null],[28,[37,2],[\"shared_words.ok\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]],[]]]],[]]]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@close\",\"modal\",\"@facebookUser\",\"@page\",\"@pages\",\"@selectPage\",\"@selectPageNotFound\"],false,[\"shared/modal\",\"action\",\"t\",\"html-safe\",\"on\",\"toggle-action\",\"if\",\"svg-jar\",\"did-insert\",\"perform\",\"shared/credentials/page-list\",\"shared/link\",\"shared/ui/button\",\"set\",\"not\"]]",
    "moduleName": "shared/components/shared/credentials/unconnected-pages.hbs",
    "isStrictMode": false
  });

  let UnconnectedPagesComponent = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class UnconnectedPagesComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "credentials", _descriptor, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "showHelpDropdown", _descriptor4, this);
    }

    get socialProfile() {
      return this.credentials.socialProfile;
    }

    get state() {
      return this.credentials.state;
    }

    get nickname() {
      return this.socialProfile.nickname;
    }

    get isCorrectPage() {
      return this.state.isCorrectPage;
    }

    get activePageId() {
      return this.state.activePage?.id;
    }

    get selectedPageBusinessAccountId() {
      return this.state.activePage?.instagram_business_account?.id;
    }

    get missingPage() {
      return this.activePageId === 0;
    }

    get activePageHasSufficientPermissions() {
      const page = this.args.pages?.find(page => page.id === this.activePageId);
      return page ? this.instagramBusiness.sufficientPermissions(page, this.socialProfile.isCreator) : false;
    }

    get alternatePageSelected() {
      return !this.isCorrectPage && this.activePageId;
    }

    *trackSelectedPage() {
      let type = 'page permissions missing';
      const response = this.socialProfile.businessAccountToken ? yield this.socialProfile.facebookTokenDebug({
        token: this.socialProfile.businessAccountToken
      }) : {};

      if (response?.scopes?.includes('pages_read_user_content')) {
        type = 'zero pages';
      }

      this.segment.track('selected-page-creds-wiz', {
        area: this.credentials.source,
        socialProfile: this.socialProfile.id,
        selected_page_type: type
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showHelpDropdown", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackSelectedPage", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "trackSelectedPage"), _class.prototype)), _class));
  _exports.default = UnconnectedPagesComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UnconnectedPagesComponent);
});